import { render, staticRenderFns } from "./TabProfissionais.vue?vue&type=template&id=fc98b15c&scoped=true"
import script from "./TabProfissionais.vue?vue&type=script&lang=js"
export * from "./TabProfissionais.vue?vue&type=script&lang=js"
import style0 from "./TabProfissionais.vue?vue&type=style&index=0&id=fc98b15c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc98b15c",
  null
  
)

export default component.exports